import { AHtml, ahtml }	from "ts-base/web/ahtml";

export const html			= ahtml<HtmlAttachment>;

export type Html			= AHtml<HtmlAttachment>;
export const Html			= AHtml;

export type HtmlFragment	= AHtml.Fragment<HtmlAttachment>;
export type HtmlRendered	= AHtml.Rendered<HtmlAttachment>;

export type HtmlAttachment	= never;
